(function () {
'use strict';

const BASE_API_URL = /staging/.test(location.href) ? 'https://staging-neo.llsapp.com' : 'https://apineo.llsapp.com';

function App(config) {
  this.$agree = document.querySelector('.agree');
  this.$checkBox = this.$agree.querySelector('.check-box');
  this.$nextBtn = document.querySelector('.next-btn');
  this.$form = document.getElementById('register');
  this.$mobile = this.$form.querySelector('input.mobile');
  this.$code = this.$form.querySelector('input.code');
  this.$getCodeBtn = this.$form.querySelector('.getcode');
  this.$submit = this.$form.querySelector('.submit');
  this.$toast = document.querySelector('.toast');
  this.$success = document.querySelector('.success');
  this.timeout = config.timeout;
  this.timer = null;
  this.agreed = true;
}

App.prototype = {
  init() {
    this.listen();
  },
  listen() {
    let buttonLock = false;
    this.$agree.addEventListener('click', () => {
      if (this.agreed) {
        this.$checkBox.style.backgroundPosition = '0 0';
        this.$nextBtn.disabled = true;
        this.agreed = false;
      } else {
        this.$checkBox.style.backgroundPosition = '-25px 0';
        this.$nextBtn.disabled = false;
        this.agreed = true;
      }
    }, false);
    this.$nextBtn.addEventListener('click', () => {
      document.querySelector('.agreement').style.display = 'none';
      document.querySelector('.register').style.display = 'block';
    }, false);
    this.$mobile.addEventListener('input', () => {
      if (this.$mobile.value.length === 11) {
        this.$getCodeBtn.disabled = false;
      } else {
        this.$getCodeBtn.disabled = true;
      }
    }, false);
    this.$getCodeBtn.addEventListener('click', () => {
      if (buttonLock) {
        return false;
      } else {
        buttonLock = true;
      }
      if (this.timer) {
        return false;
      }
      const mobile = this.$mobile.value;
      if (mobile.length === 0) {
        this.errorMsg('请先输入您的手机号！');
      } else if (mobile.length !== 11) {
        this.errorMsg('您的手机号格式不正确！');
      } else {
        this.$getCodeBtn.disabled = true;
        this.getCode({
          mobile: mobile,
          success: () => {
            buttonLock = false;
            this.$getCodeBtn.disabled = true;
            this.$getCodeBtn.textContent = this.timeout + 's后可重发';
            this.countdown((time) => {
              this.$getCodeBtn.textContent = time + 's后可重发';
            }, () => {
              this.$getCodeBtn.disabled = false;
              this.$getCodeBtn.textContent = '获取验证码';
            });
          },
          error: () => {
            buttonLock = false;
            this.$getCodeBtn.disabled = false;
            this.$getCodeBtn.textContent = '获取验证码';
          },
        });
      }
    }, false);
    this.$submit.addEventListener('click', ev => {
      ev.preventDefault();
      ev.stopPropagation();
      if (buttonLock) {
        return false;
      }
      const mobile = this.$mobile.value;
      const code = this.$code.value;
      if (mobile.length > 0 && code.length > 0) {
        buttonLock = true;
        this.$submit.disabled = true;
        this.$submit.textContent = '验证中...';
        this.register({
          mobile: mobile,
          code: code,
          success: () => {
            buttonLock = false;
            this.$submit.textContent = '提交';
            this.$submit.disabled = false;
            this.$success.style.display = 'block';
          },
          error: () => {
            buttonLock = false;
            this.$submit.textContent = '提交';
            this.$submit.disabled = false;
          },
        });
      } else {
        this.errorMsg('短信验证码不正确！');
      }
    }, false);
  },
  getCode(options) {
    this.xhr({
      url: BASE_API_URL + '/api/v1/campaigns/darwin_agreements/code',
      data: JSON.stringify({
        mobile: options.mobile,
      }),
      type: 'POST',
      contentType: 'application/json',
      success: (resp) => {
        const data = JSON.parse(resp);
        if (data.success) {
          options.success();
        }
      },
      error: (resp) => {
        const data = JSON.parse(resp);
        options.error();
        this.errorMsg(data.error);
      },
    });
  },
  register(options) {
    this.xhr({
      url: BASE_API_URL + '/api/v1/campaigns/darwin_agreements',
      data: JSON.stringify({
        mobile: options.mobile,
        code: options.code,
      }),
      type: 'POST',
      contentType: 'application/json',
      success: (resp) => {
        const data = JSON.parse(resp);
        if (data.success) {
          options.success(data);
        } else {
          this.errorMsg(data.error);
        }
      },
      error: (resp) => {
        const data = JSON.parse(resp);
        options.error();
        this.errorMsg(data.error);
      },
    });
  },
  countdown(tick, finish) {
    let current = this.timeout;
    this.timer = window.setInterval(() => {
      current--;
      if (current > 0) {
        tick(current);
      } else {
        finish();
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }, 1000);
  },
  xhr(options) {
    const request = new XMLHttpRequest();
    request.open(options.type, options.url, true);
    request.setRequestHeader('Content-Type', options.contentType);
    request.onload = () => {
      const resp = request.responseText;
      if (request.status >= 200 && request.status < 400) {
        if (typeof options.success === 'function') {
          options.success(resp);
        }
      } else {
        if (typeof options.error === 'function') {
          options.error(resp);
        }
      }
    };
    request.onerror = () => {
      options.error(JSON.stringify({error: '网络异常，请稍后再试'}));
    };
    request.send(options.data);
  },
  errorMsg(msg) {
    this.$toast.querySelector('.content').textContent = msg;
    this.$toast.style.display = 'table';
    window.setTimeout(() => {
      this.$toast.style.display = 'none';
    }, 3000);
  },
};

const app = new App({
  timeout: 60,
});
console.log(app);
app.init();

}());
